import EventEmitter from 'eventemitter3'

export const createEventBus = () => new EventEmitter();

export enum EventTypes {
    ORDER_TYPE_CHANGED = "order_type_change",
    ORDER_TYPE_CHANGED_LOCATIONS = "order_type_change_locations",
    LOGGED_IN = "logged_in",
    LOGGED_OUT = "logged_out",
    LOCATION_SELECTION = "location_selection",
    LOCATION_CHANGE = "location_change",
    LOCATION_REROUTE = "location_reroute",
    LOCATIONS_CREATED = "locations_created",
    DELIVERY_ADDRESS_CHANGED = "delivery_address_changed",
    STORE_CHANGED = "store_changed",
    DATA_RETRIEVED = "data_retrieved",
    DATALAYER_LOADED = "datalayer_loaded",
    BRAND_DATA_RETRIEVED = "brand_data_retrieved",
    HEADER_NAME_CHANGE = "header_name_change",
    ITEM_ADD = "item_add",
    ITEM_REMOVE = "item_remove",
    MEAL_DEAL_OPEN = "meal_deal_open",
    MODAL_OPEN = "modal_open",
    MODAL_CLOSE = "modal_close",
    MODAL_CLOSED = "modal_closed",
    CART_CHANGED = "cart_changed",
    FAV_STORE_ADD = "fav_store_add",
    FAV_STORE_REMOVE = "fav_store_remove",
    FAV_ITEM_SAVE = "fav_item_save",
    FAV_ITEM_ADD = "fav_item_add",
    FAV_ITEM_DELETE = "fav_item_remove",
    MENU_ANCHOR = "menu_anchor",
    ORDER_COMPLETED = "order_completed",
    ORDER_COUPON_CHANGED = "order_coupon_changed",
    COUPON_INVALID = "coupon_invalid",
    TIME_CHANGED = "time_changed",
    SCHEDULE_DATE_CHANGED = "schedule_date_changed",
    LIMITED_TIME_EXPIRED = "limited_time_expired",
    LIMITED_TIME_CONFIRMED = "limited_time_confirmed",
    REWARD_REMOVED = "reward_removed",
    USER_CHANGED = "user_changed",
    LANGUAGE_CHANGED = "language_changed",
    GIFT_CARD_CHANGED = "gift_card_changed",
    CHECKOUT_CONTACTLESS = "checkout_contactless",
    MENU_PLACEHOLDERS = "menu_placeholders",
    HEADER_CANCEL = "header_cancel",
    COOKIE_PREFERENCE = "cookie_preference",
    CUSTOMIZE_ITEM_SIZE_CHANGE = "customize_item_size_change",
    CUSTOMIZE_ITEM_PRICE_CHANGE = "customize_item_price_change",
    CUSTOMIZE_ITEM_CALORIES_CHANGE = "customize_item_calories_change",
    CUSTOMIZE_ITEM_MODIFIER_CLICKED = "customize_item_modifier_clicked",
    CUSTOMIZE_ITEM_MODIFIER_SIZE_CLICKED = "customize_item_modifier_size_clicked",
    CUSTOMIZE_ITEM_MODIFIER_HALF_CLICKED = "customize_item_modifier_half_clicked",
    CUSTOMIZE_ITEM_MODIFIER_PREMODIFIER_CLICKED = "customize_item_modifier_premodifier_clicked",
    CLEAR_CART = "clear_cart",
    SELECT_SECOND_HALF_OPEN = "select_second_half_open",
    SELECT_SECOND_HALF_SELECTED = "select_second_half_selected",
}